"use strict";

var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");

const _excluded = ["loading", "disabled", "type", "className", "buttonType", "ariaLabel", "id", "dataTestId", "ariaPressed", "onClick", "children", "forwardedRef"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttonsModule = _interopRequireDefault(require("../../tools/buttons.module.scss"));

var _spinner = _interopRequireDefault(require("../spinner"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Common button
// ================
// The default button is the secondary button. Pass primary={true} to
// override.


function dashToCamelCase(string) {
  const str = string.replace(/-([a-z])/g, g => g[1].toUpperCase());
  return str.charAt(0).toUpperCase() + str.slice(1);
}

class Button extends _react.Component {
  className(type) {
    let disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _buttonsModule.default["Button".concat(dashToCamelCase(type)).concat(disabled ? 'Disabled' : '')];
  }

  render() {
    const _this$props = this.props,
          {
      loading,
      disabled,
      type,
      className,
      buttonType,
      ariaLabel,
      id,
      dataTestId,
      ariaPressed,
      onClick,
      children,
      forwardedRef
    } = _this$props,
          props = _objectWithoutProperties(_this$props, _excluded); // Always disabled when loading


    const isDisabled = loading || disabled;
    const classNames = (0, _classnames.default)(this.className(type, isDisabled), className);
    const attributes = {};

    if (isDisabled) {
      attributes.disabled = 'disabled';
    }

    if (buttonType) {
      attributes.type = buttonType;
    }

    return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
      className: classNames,
      "aria-label": ariaLabel,
      id: id,
      "data-test-id": dataTestId,
      "aria-pressed": ariaPressed,
      ref: forwardedRef,
      onClick: onClick
    }, attributes, props), loading ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
      className: _buttonsModule.default.Spinner
    }) : /*#__PURE__*/_react.default.createElement("span", {
      className: _buttonsModule.default.text
    }, children));
  }

}

exports.default = Button;
const ButtonProps = {
  type: _propTypes.default.oneOf(['primary', 'secondary', 'secondary-light', 'tertiary', 'tertiary-light', 'inferior']),
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  buttonType: _propTypes.default.oneOf(['submit', 'reset', 'button']),
  ariaLabel: _propTypes.default.string,
  ariaPressed: _propTypes.default.bool,
  id: _propTypes.default.string,
  dataTestId: _propTypes.default.string,
  forwardedRef: _propTypes.default.string
};
exports.ButtonProps = ButtonProps;
Button.propTypes = ButtonProps;
Button.defaultProps = {
  type: 'primary',
  loading: false,
  disabled: false
};